<template>
  <div class="validateShow">
    <common-header :headerId="'4'"></common-header>
    <div
      class="inquire"
      v-if="showSata"
      :style="{'background':openEn?'#eee':'#eee'}"
    >
      <no-list v-if="openEn"></no-list>
      <template v-else>
        <div class="inquire_list">
            <div class="inquire-box">
                <span class="goback" style="color:#4E94FF;top:51px;" @click="goback">返回</span>
                <h3 class="inquire-message">
                    <span class="success">
                    <img src="~img/validateQuery/pass_icon.png" />
                    </span>
                </h3>
               <p
          class="inquire-text"
          v-if="checkEnclosure"
        >经验证，申请人提交的电子数据与下列主证书下附件的数字指纹完全相符。确认该文件在系统中进行了保全！</p>
        <p
          class="inquire-text"
          v-else
        >经验证，申请人提交的电子数据与下列原始文件的数字指纹完全相符。确认该文件在系统中进行了保全！</p>
            </div>
            <div class="enclosure_list">
            <div class="content">
                <table class="table tables" border="1">
                <thead style="width:1200px;">
                    <tr class="tr-header">
                    <td style="width:4%">序号</td>
                    <td style="width:9%">主证书编号</td>
                    <template v-if="checkEnclosure">
                        <td style="width:15%">附件SHA512摘要</td>
                        <td style="width:15%">附件区块链保全ID</td>
                        <td style="width:6%">附件保全时间</td>
                        <td style="width:6%">附件有效状态</td> 
                        <td style="width:6%">出证状态</td>
                    </template>
                    <template v-else>
                        <td style="width:15%">SHA512摘要</td>
                        <td style="width:15%">区块链保全ID</td>
                        <td style="width:6%">保全时间</td>
                        <td style="width:6%">有效状态</td>
                        <td style="width:6%">出证状态</td>
                    </template>
                    <td style="width:7%">操作</td>
                    </tr>
                </thead>
                <tbody
                    style=" display: block;
                max-height: 305px;
                overflow-y: auto;"
                >
                    <tr
                    v-for="(item,index) in certifiCateList"
                    :style="{'height':'60px','font-weight':curInfo==index?'bold':'normal','background-color':curInfo==index?'#F1F6F9 !important':'#F8F8F8'}"
                    :key="index"
                    >
                    <td style="width:4%">{{index+1}}</td>
                    <td style="width:9%">{{item.certificateNumber}}</td>
                    <td style="width:15%;padding:0px 5px;">{{item.certSha512?item.certSha512:item.fileHash512}}</td>
                    <td style="width:15%;padding:0px 5px;">{{item.txId}}</td>
                    <td style="width:6%">{{item.signDate?item.signDate.split(' ')[0]:item.certificateTime?item.certificateTime.split(' ')[0]:''}}<br>{{item.signDate?item.signDate.split(' ')[1]:item.certificateTime?item.certificateTime.split(' ')[1]:''}}</td> 
                    <td style="width:6%">{{ item.enabled==0?'过期':'有效' }}</td>
                    <td style="width:6%">{{ item.certificateStatus ==0?'未出证':item.certificateStatus ==2?'出证失败':'已出证' }}</td>
                    <td class="judialPosition" style="width:7%">
                      <span
                        class="see_btn"
                        :style="{'font-weight':curInfo==index?'bold':'normal'}"
                        @click="seeCertificate(index)"
                        >查看</span>
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
            </div>
        </div>

        <div class="certificate new_certificate" :style="{'margin-bottom':'20px','height':$route.query.partnerId==23?'920px':'756px'}">
          <!-- <div class="pageHeader"> -->
            <!-- <span style="color:#e2344a">{{ListIndex}}</span>/<span>{{AllPages}}</span> -->
          <!-- </div> -->
          <!-- <div class="pageIcon-left" v-if="$route.query.ListIndex >= 1">
            <img src="~img/validateQuery/light_nor_icon.png" />
          </div>
          <div class="pageIcon-right" v-if="$route.query.ListIndex <= AllPages">
            <img src="~img/validateQuery/right_nor_icon.png" />
          </div> -->
          <!-- <div class="pdf_left" v-if="isChangePageLeft" @click="changePage(true)"></div>
          <div class="pdf_right" v-if="isChangePageRight" @click="changePage(false)"></div> -->
          <div class="noData" v-if="certifiCateList[curInfo] && (certifiCateList[curInfo].certificateStatus ==0 || certifiCateList[curInfo].certificateStatus ==2) ">
            <img src="../../assets/images/common/nodata.png"/>
           证据已保全，但尚未出证书，需要出证后才能查验。
          </div>
          <div class="noData" v-else-if="certifiCateList[curInfo] && (certifiCateList[curInfo].certificateStatus ==1 && certifiCateList[curInfo].enabled ==0) ">
            <img src="../../assets/images/common/nodata.png"/>
            非常抱歉，证据已过期，暂不支持查询！
          </div>
          <certificate v-else class="certificate_show" :certificateList="queryParams"></certificate>
        </div>
      </template>
    </div>
    <div v-else>
      <div class="verify" :style="{'background':openEn?'#eee':'#eee'}">
        <no-list v-if="openCn"></no-list>
        <template v-else>
          <div class="verify-box" :style="{'width':$route.query.partnerId==23?'1150px':'990px'}">
            <span class="goback" @click="goback">返回</span>
            <h3 class="verify-message">
              <span class="success">
                <img src="~img/validateQuery/pass_icon.png" />
              </span>证书存在：该保全信息存在且未被篡改
            </h3>
          </div>
          <div class="certificate verify-certificate" :style="{'width':$route.query.partnerId==23?'1150px':'990px'}">
            <div class="certificateShow" :style="{'width':$route.query.partnerId==23?'1150px':'990px'}">
              <certificate-show @nolist="nolists" :queryCerificate="queryCerificate"></certificate-show>
            </div>
          </div>
        </template>
      </div>
    </div>
    <loading-absolute v-if="$store.state.showLoading" v-show="!openCn || !openEn"></loading-absolute>
  </div>
</template>

<script>
import NoList from "../common/NoList";
import certificate from "@/components/common/CommonCertificate";
import certificateShow from "@/components/common/Certificate";
import LoadingAbsolute from "../common/LoadingAbsolute";
export default {
  data() {
    return {
      openEn: false,
      openCn: false,
      isChangePageLeft: true,
      isChangePageRight: true,
      headerIds: 4,
      showSata: this.$route.query.currentType == 1 ? true : false,
      queryParams: {},
      certifiCateList: [],
      ListIndex: 1,
      AllPages: "",
      queryCerificate: {},
      curInfo:0,
      InfoData: {},
      curVcode:"",
      checkEnclosure:'',
    };
  },
  components: { certificate, certificateShow, LoadingAbsolute, NoList },
  mounted() {
    // this.checkEnclosure = this.$route.query.checkEnclosure;
    // this.ListIndex = this.$route.query.ListIndex;
    //   window.sessionStorage.setItem(this.$route.query.certificateNumber,JSON.stringify(res.data.extraData.list))
    if (this.showSata) {
      if (this.$route.query.certificateNumber) {
        this.certifiCateList = window.sessionStorage.getItem(
          this.$route.query.certificateNumber
        )
          ? JSON.parse(
              window.sessionStorage.getItem(this.$route.query.certificateNumber)
            )
          : [];
      }
      if (!this.certifiCateList.length) {
        this.openEn = true;
        this.$store.commit("showLoading", false);
        return;
      } else {
        this.openEn = false;
      }
      this.AllPages = this.certifiCateList.length;
      this.init();
    } else {
      this.queryCerificate = this.$route.query;
    }
  },
  created(){
     this.checkEnclosure = this.$route.query.checkEnclosure?JSON.parse(this.$route.query.checkEnclosure):'';
  },
  methods: {
    init() {
      this.getCertificate();
    },
    seeCertificate(index) {
      this.curInfo = index;
      this.getCertificate();
      this.backTop();
    },
    backTop() {
      $(window).scrollTop(data => {
        $("html").css({ height: "auto" });
        $("body,html").animate({
          scrollTop: $(".new_certificate").offset().top
        });
      });
    },
    nolists(open) {
      this.openCn = open;
    },
    goback() {
      this.$router.push("/cn/validateQuery");
    },
    // changePage(is) {
    //   let fullPath =
    //     this.$route.fullPath.substring(
    //       0,
    //       this.$route.fullPath.indexOf("ListIndex=")
    //     ) + "ListIndex=";
    //   this.ListIndex = this.$route.query.ListIndex;
    //   is ? this.ListIndex-- : this.ListIndex++;
    //   if (this.ListIndex >= this.certifiCateList.length) {
    //     this.ListIndex = this.certifiCateList.length;
    //     this.isChangePageRight = false;
    //     this.isChangePageLeft = true;
    //   } else if (this.ListIndex <= 0) {
    //     this.ListIndex = 1;
    //     this.isChangePageLeft = false;
    //     this.isChangePageRight = true;
    //   } else {
    //     this.isChangePageLeft = true;
    //     this.isChangePageRight = true;
    //   }
    //   this.$store.commit("showLoading", true);
    //   this.$router.push(
    //     fullPath +
    //       this.ListIndex +
    //       "&uid=" +
    //       this.certifiCateList[this.ListIndex - 1].userId +
    //       "&partnerId=" +
    //       this.certifiCateList[this.ListIndex - 1].partnerId +
    //       "&certificateNumber=" +
    //       this.$route.query.certificateNumber
    //   );
    //   this.getCertificate();
    // },
    getCertificate(uids) {
      this.$ajax
        .get("/webapi/validateQuery/getCertificate", {
          params: {
            uid: this.certifiCateList[this.curInfo]
              ? this.certifiCateList[this.curInfo].userId
              : "",
            certificateNumber: this.certifiCateList[
            this.curInfo
            ]
              ? this.certifiCateList[this.curInfo]
                  .certificateNumber
              : "",
            type: this.certifiCateList[this.curInfo]
              ? this.certifiCateList[this.curInfo].type
              : "",
            partnerId: this.certifiCateList[this.curInfo]
              ? this.certifiCateList[this.curInfo].partnerId
              : "",
            certificateToken: "truthso-certificate"
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.openEn = false;
            this.queryParams = res.data.extraData;
            this.queryParams.uid = this.certifiCateList[
             this.curInfo
            ].userId;
            this.queryParams.QRCode = res.data.QRCodeUrl;
            this.queryParams.partnerId = this.certifiCateList[
             this.curInfo
            ].partnerId;
          } else if (res.data.code == 402) {
            this.openEn = true;
            this.$store.commit("showLoading", false);
          } else if (res.data.code == 100) {
            this.openEn = true;
          } else if (res.data.code == 101) {
            // this.openEn=true;
          }
          this.$store.commit("showLoading", false);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.validateShow > img {
  display: inline-block;
}
.content {
  background: #eee;
}

.validateShow {
  width: 100%;
  /* height: 810px;
    overflow: hidden;
    background: url(../../../assets/images/info/validateQuery/bottom.png) 100% 100% repeat; */
}
.inquire {
  width: 100%;
  min-height: 954px;
  overflow: hidden;
  /* background: url(../../../assets/images/info/validateQuery/bottom.png) 100% 100% repeat; */
  .enclosure_list {
    width: 100%;
    // max-height: 438px;
    background: #fff;
    padding-bottom: 40px;
    margin-top: 27px;
    .content {
      width: 1200px;
      margin: 0 auto;
    }
    .see_btn {
      font-size: 16px;
      font-weight: 500;
      color: #4e94ff;
    }
  }
}
table * {
  box-sizing: border-box;
}

table.table {
  width: 100%;
  border-collapse: collapse;
  color: #7e7e7e;
  /*overflow: hidden;*/
}

.table>tr>td,
.table thead>tr>td,
.table>tbody>tr>td,
.table>tr>th,
.table thead>tr>th,
.table tbody>tr>th {
  height: 34px;
  text-align: center;
  vertical-align: middle;
  word-break: break-all;
  font-size: 12px;
}

.table > tr:nth-child(even),
.table thead > tr:nth-child(even),
.table tbody > tr:nth-child(even) {
  background: #F8F8F8;
}
.tables > tr:nth-child(odd),
.tables thead > tr:nth-child(odd),
.tables tbody > tr:nth-child(odd) {
  background: #fff !important;
}
.tables thead tr.tr-header {
  background:#D7DDE0 !important;
  border: 0px;
  height:40px;
  td {
    font-size: 16px;
    font-weight: 500;
    color: #595959;
    border: 0px;
  }
}
.tables > tbody tr {
  cursor: pointer;
  border: 0px;
  td {
    border: 0px;
  }
}

.tables thead{
    width: 1200px;
    display: table;
    table-layout: fixed;
    text-align: center;
    line-height: 40px;
}
.tables tbody::-webkit-scrollbar{
    width: 3px !important;
}
.tables tbody::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background: #ccc;
}
table.tables {
  border: 1px solid #d2d2d2;
}
.enclosure_paging {
  width: 100%;
  margin: 26px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .page-box {
    width:auto;
    margin: 0 auto;
  }
}
.verify {
  width: 100%;
  /*height: 784px;*/
  overflow: hidden;
  background: #eee;
  /* background: url(../../../assets/images/info/validateQuery/bottom.png) 100% 100% repeat; */
}

.inquire-box,
.verify-box {
  width: 990px;
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;
}

.inquire-box {
  height: 132px;
  margin: 33px auto 0 auto;
  //  background-image: url("~img/validateQuery/pass_bg_img.png"); 
}

.inquire-box {
  height: 115px;
}
.inquire_list{
    width: 100%;
    height: auto;
    background: #fff;
    margin-top: -33px;
    padding-top: 10px;
}

.verify-box {
  height: 84px;
  margin: 40px auto 0 auto;
  background-image: url("~img/validateQuery/pass_bg_img1.png");
  background-size: 100% 100%;
}

.inquire-message,
.verify-message {
  font-size: 16px;
  line-height: 16px;
  font-weight: normal;
  text-align: center;
  color: #4c4c4c;
}
.inquire-message {
  line-height: 44px;
}
.inquire-message .success {
  margin: 10px 10px 7px 0;
}
.success {
  display: inline-block;
  vertical-align: middle;
  margin: 29px 10px 30px 0;
}
.inquire-text {
  font-size: 14px;
  line-height: 22px;
  width: 462px;
  margin: 0 auto;
  text-align: center;
  color: #818080;
}
.certificate {
  width: 1050px;
  height: 756px;
  margin: 0 auto;
  position: relative;
}
.download-certificate {
  width: 460px;
  height: 587px;
  border: 1px solid #000;
  float: right;
  margin-top: 32px;
}
.inquire-certificate {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}

.goback {
  cursor: pointer;
  position: absolute;
  top: 30px;
  left: 23px;
  color: #e2344a;
}

.goback:hover {
  text-decoration: underline;
}
.certificateShow {
  margin-top: 10px;
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  /*width: 100%;*/
  /*margin-left: -30px;*/
}

.certificate_show {
  position: absolute;
  top: 35px;
  left: 50%;
  transform: translate(-50%, 0);
}
.pageHeader {
  height: 20px;
  text-align: center;
  line-height: 20px;
  position: absolute;
  left: 50%;
  top: 12px;
  transform: translate(-50%);
}

.pageIcon-left,
.pageIcon-right {
  z-index: 99;
}

.pageIcon-left,
.pdf_left {
  width: 26px;
  height: 34px;
  position: absolute;
  left: 50px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 100;
}
.pdf_left {
  display: block;
  background: url("../../assets/images/validateQuery/left-1.png");
}
.pdf_left:hover {
  background: url("../../assets/images/validateQuery/left-hover.png");
}
.pageIcon-right,
.pdf_right {
  width: 26px;
  height: 34px;
  position: absolute;
  right: 50px;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  z-index: 100;
}
.pdf_right {
  display: block;
  background: url("../../assets/images/validateQuery/right-1.png");
}
.pdf_right:hover {
  background: url("../../assets/images/validateQuery/right-hover.png");
}
.noData{
  width: 470px;
  height: 690px;
  border: 1px solid #ccc;
  text-align: center;
  background: #fff;
  margin: 30px auto;
  color: #595959;
  img{
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
    margin-top: 50%;
    transform: translateY(-50%);

  }

}
</style>
